class QuestionModalController {
  constructor(EventEmitter,$transclude) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.transclude = $transclude;
  }

  buttonClick(option) {
    this.onSelection(this.EventEmitter({ selection: option }));
  }

  $postLink(){
    this.hasDescriptionTextarea = this.transclude.isSlotFilled('descriptionTextarea');
  }

}

export default QuestionModalController;



// WEBPACK FOOTER //
// ./client/app/components/questionModal/questionModal.controller.js